const React = require('react');
const PropTypes = require('prop-types');
const { isMobile } = require('utilities/browserUtils');
const PortfolioHoldingsDesktop = require('./PortfolioHoldingsDesktop');
const PortfolioHoldingsMobile = require('./PortfolioHoldingsMobile');


const PortfolioHoldingsTable = ({ data }) => (
    isMobile()
    ? <PortfolioHoldingsMobile data={data} />
    : <PortfolioHoldingsDesktop data={data} />
);


PortfolioHoldingsTable.propTypes = {
    data: PropTypes.array.isRequired,
};


module.exports = PortfolioHoldingsTable;
